'use client';

var Awards = "Giải thưởng";
var Bonus = "Thưởng";
var Canteen = "Căn-tin";
var Kindergarten = "Trông trẻ";
var Mobile = "Điện thoại";
var Training = "Đào tạo";
var Transportation = "Trợ cấp đi lại";
var Library = "Thư viện";
var Travel = "Du lịch";
var Vouchers = "Thưởng quà";
var Others = "Khác";
var viLang = {
	Awards: Awards,
	Bonus: Bonus,
	Canteen: Canteen,
	"Healthcare Plan": "Khám sức khoẻ",
	Kindergarten: Kindergarten,
	Mobile: Mobile,
	"Paid Leave": "Nghỉ phép",
	"Team Activities": "Hoạt động nhóm",
	Training: Training,
	Transportation: Transportation,
	Library: Library,
	Travel: Travel,
	Vouchers: Vouchers,
	Others: Others
};

export { Awards, Bonus, Canteen, Kindergarten, Library, Mobile, Others, Training, Transportation, Travel, Vouchers, viLang as default };
//# sourceMappingURL=vi.json.js.map
